"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileListTools = void 0;
var React = require("react");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var mobile_1 = require("@caddigital/sok-ui/lib/utils/mobile");
var dispatch_1 = require("./utils/dispatch");
var UseReMapState_1 = require("./hooks/UseReMapState");
var utils_1 = require("./utils");
require("./styles.scss");
var MobileToolbarWrapper_1 = require("./components/MobileToolbarWrapper");
var ToolBarWrapper_1 = require("./components/ToolBarWrapper");
var FileListTools = function (props) {
    var _a = (0, react_1.useState)(false), removeIsOpen = _a[0], setRemoveIsOpen = _a[1];
    var _b = (0, react_1.useState)(false), createSubprojectIsOpen = _b[0], setCreateSubprojectIsOpen = _b[1];
    var _c = (0, react_1.useState)(false), archiveSubprojectIsOpen = _c[0], setArchiveSubprojectIsOpen = _c[1];
    var _d = (0, react_redux_1.useSelector)(function (state) { return ({
        user: state.auth.current.user,
        properties: state.files.filesFolderProperties,
        currentFolder: state.files.currentFolder,
        selectedItems: state.files.selectedItems,
        folderPath: state.files.folderPath
    }); }), user = _d.user, properties = _d.properties, currentFolder = _d.currentFolder, selectedItems = _d.selectedItems, folderPath = _d.folderPath;
    var externalProps = (0, utils_1.setFileListToolsExternalProps)(props, user);
    var states = (0, utils_1.setStateProps)(properties, currentFolder, selectedItems, folderPath);
    var internalProps = (0, utils_1.setInternalProps)(removeIsOpen, setRemoveIsOpen, createSubprojectIsOpen, setCreateSubprojectIsOpen, archiveSubprojectIsOpen, setArchiveSubprojectIsOpen);
    var dispatchers = (0, dispatch_1.mapDispatchToProps)((0, react_redux_1.useDispatch)());
    var reMappedProps = (0, UseReMapState_1.useReMapState)(externalProps, internalProps, dispatchers, states);
    if (props.isMobile || mobile_1.isMobile) {
        if (!currentFolder) {
            return null;
        }
        return React.createElement(MobileToolbarWrapper_1.MobileToolbarWrapper, __assign({}, reMappedProps));
    }
    return React.createElement(ToolBarWrapper_1.ToolbarWrapper, __assign({}, reMappedProps));
};
exports.FileListTools = FileListTools;
exports.default = exports.FileListTools;
